import React from "react";
import styles from "../../../Styles/Modules/Button.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { playSound } from "../../../State/Slices/soundsSlice";
import { SOUND_NAME } from "../../../sounds";
import {
  setTriggerFreeSpinIntroOutPhase,
  setTriggerFreeSpinOutroOutPhase,
  setTriggerFreeSpinInfoOutPhase,
} from "../../../State/Slices/animationsSlice";
import {
  setFreeSpinActive,
  setShowFreeSpinGame,
} from "../../../State/Slices/freeSpinsSlice";

const ButtonFreeSpinStart = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    freeSpinIntroAnimationStarted,
    freeSpinOutroAnimationStarted,
    freeSpinInfoAnimationStarted,
  } = useSelector((state) => state.animations);

  // Determine the button title based on the animation state
  const buttonTitle = freeSpinIntroAnimationStarted
    ? t("start_free_spin")
    : freeSpinOutroAnimationStarted
    ? t("finish_free_spin")
    : t("start_free_spin");

  // Define the handleClick function to handle button click events
  const handleClick = () => {
    dispatch(playSound(SOUND_NAME.click));

    if (freeSpinIntroAnimationStarted) {
      dispatch(setTriggerFreeSpinIntroOutPhase(true));
      dispatch(setShowFreeSpinGame(true));
      setTimeout(() => {
        dispatch(setFreeSpinActive(true));
      }, 1500);

      console.log("Free spin active");
    } else if (freeSpinOutroAnimationStarted) {
      dispatch(setTriggerFreeSpinOutroOutPhase(true));
      dispatch(setShowFreeSpinGame(false));
    } else if (freeSpinInfoAnimationStarted) {
      dispatch(setTriggerFreeSpinInfoOutPhase(true));
    }
  };

  // Return the button element with styles and event handlers
  return (
    <button
      className={`${styles.button} ${styles.buttonStandard}`} // Apply CSS styles from the imported stylesheet
      title={buttonTitle} // Set the button's title attribute based on the animation state
      onClick={handleClick} // Attach the handleClick function to the button's onClick event
    >
      {buttonTitle}
    </button>
  );
};

// Export the ButtonAutoPlay component as the default export
export default ButtonFreeSpinStart;
